import auth from "../../firebase/auth";
import api from "../../api";
import { createSuccess, createError } from "../../libs/flash-messages";

const findIndex = (state, form) => {
   return state.licenses.findIndex(license => {
      return license._id === form._id;
   });
}

const state = {
   activeWebsite: null,
   activeLicense: null,
   licenseSites: [
      "Flat Branch Home Loans",
      "Fast Forward"
   ],
   licenses: null
};

const getters = {
   getLicenses(state) {
      if (state.licenses) {
         return state.licenses.sort((a, b) => {
            if (a.state > b.state) {
               return 1;
            }
            if (a.state < b.state) {
               return -1
            }
            return 0
         });
      }
      return [];
   },
   getLicenseSites() {
      return state.licenseSites;
   },
   getActiveWebsite(state) {
      return state.activeWebsite;
   },
   getActiveLicense(state) {
      return state.activeLicense;
   }
};

const actions = {
   async startSetLicenses({ commit, rootState }) {
      const token = rootState.user.token;
      await auth.refreshFlow(auth.provider);
      try {
         const licenses = await api.axiosGet(`/api/compliance/licenses/`, token);
         commit('SET_LICENSES', licenses);
      } catch (err) {
         createError("Failed to fetch licenses", err)
      }
   },
   startUnsetLicenses({ commit }) {
      commit('SET_LICENSES', null);
   },
   startSetActiveWebsite({ commit }, site) {
      commit('SET_ACTIVE_WEBSITE', site);
   },
   startSetActiveLicense({ commit }, license) {
      commit('SET_ACTIVE_LICENSE', license);
   },
   async startCreateLicense({ rootState }, form) {
      const token = rootState.user.token;
      await auth.refreshFlow(auth.provider);
      try {
         const license = await api.axiosPost(`/api/compliance/licenses/`, form, token);
         this._vm.$socket.io.nsps["/compliance"].emit("CREATE_LICENSE", license)
         createSuccess("Successfully created!");
      } catch (err) {
         createError("Failed to create license", err);
         Promise.reject(err);
      }
   },
   async startUpdateLicenses({ rootState }, form) {
      const token = rootState.user.token;
      await auth.refreshFlow(auth.provider);
      const id = form._id;
      try {
         await api.axiosPut(`/api/compliance/licenses/${id}`, form, token);
         this._vm.$socket.io.nsps["/compliance"].emit("UPDATE_LICENSE", form);
         createSuccess(`Successfully updated: ${form.state} | ${form.website}`);
      } catch (err) {
         createError("Failed to update license", err);
         return Promise.reject(err);
      }
   },
   async startDeleteLicense({ rootState }, form) {
      const token = rootState.user.token;
      await auth.refreshFlow(auth.provider);
      const id = form._id;
      try {
         await api.axiosDelete(`/api/compliance/licenses/${id}`, token);
         this._vm.$socket.io.nsps["/compliance"].emit("DELETE_LICENSE", form);
         createSuccess(`Successfully deleted: ${form.state} | ${form.website}`);
      } catch (err) {
         createError("Failed to delete license", err);
         return Promise.reject(err);
      }
   }
};

const mutations = {
   SET_LICENSES(state, data) {
      state.licenses = data;
   },
   SET_ACTIVE_WEBSITE(state, site) {
      state.activeWebsite = site;
   },
   SET_ACTIVE_LICENSE(state, license) {
      state.activeLicense = license;
   },
   SOCKET_COMP_CREATE_LICENSE(state, license) {
      if (state.licenses) {
         state.licenses.push(license);
      } else {
         state.licenses = [license];
      }
   },
   SOCKET_COMP_UPDATE_LICENSE(state, form) {
      const licenseFound = findIndex(state, form);
      state.licenses.splice(licenseFound, 1, form);
   },
   SOCKET_COMP_DELETE_LICENSE(state, form) {
      const licenseFound = findIndex(state, form);
      state.licenses.splice(licenseFound, 1);
   }
};

export default {
   state,
   getters,
   actions,
   mutations
}